import { render } from "./DetailSakuhinTable.vue?vue&type=template&id=1572bd86&scoped=true"
import script from "./DetailSakuhinTable.vue?vue&type=script&lang=js"
export * from "./DetailSakuhinTable.vue?vue&type=script&lang=js"

import "./DetailSakuhinTable.vue?vue&type=style&index=0&id=1572bd86&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1572bd86"]])

export default __exports__